import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const LoginForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { login, loginWithSso, ssoEnabled } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login({ email, password });
      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Login fehlgeschlagen');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSso = async () => {
    setError('');
    setIsLoading(true);
    try {
      await loginWithSso('/');
    } catch (err: any) {
      setError(err.message || 'SSO-Anmeldung fehlgeschlagen');
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-card">
      <p className="auth-brand">Intermal</p>
      <h2 className="auth-title">Anmelden</h2>
      <p className="auth-subtitle">
        {ssoEnabled
          ? 'Melden Sie sich mit Ihrem SecTepe-Konto an'
          : 'Melden Sie sich bei Ihrem Konto an'}
      </p>

      {error && (
        <div className="alert alert-error">
          {error}
        </div>
      )}

      {ssoEnabled ? (
        // Keycloak owns the credentials in every deployed installation: the
        // backend runs with OIDC_ENABLED=true and rejects /api/auth/login
        // without a bearer token, so no password form is offered here.
        <button
          type="button"
          onClick={handleSso}
          disabled={isLoading}
          className="btn btn-primary btn-full"
        >
          {isLoading ? 'Weiterleitung zu SecTepe SSO...' : 'Mit SecTepe SSO anmelden'}
        </button>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              E-Mail
            </label>
            <input
              type="email"
              id="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Passwort
            </label>
            <input
              type="password"
              id="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary btn-full"
          >
            {isLoading ? 'Wird angemeldet...' : 'Anmelden'}
          </button>
        </form>
      )}
    </div>
  );
};

export default LoginForm;
